import { SiteFooter } from "@/shared/layout/SiteFooter";
import { SiteHeader } from "@/shared/layout/SiteHeader";
import { Outlet } from "react-router-dom";
import FloatingButtons from "../components/FloatingButtos";

export default function AppShell() {
  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />

      <main className="flex-1">
        {/* Local boundary keeps header/footer mounted while a lazy route chunk loads. */}
        {/* <Suspense fallback={<Loader message="Loading..." />}> */}
        <Outlet />
        {/* </Suspense> */}
      </main>

      <SiteFooter />
      <FloatingButtons />
    </div>
  );
}
